// extracted by mini-css-extract-plugin
export default {"team":"Team_team__xYkD5","boximage":"Team_boximage__-Tu8r","desc":"Team_desc__cz6YH","instagram":"Team_instagram__aCEDO","instagramlogo":"Team_instagramlogo__tNI01"};